import { preview } from '@/components/form/preview'
import { useCallback, useState } from 'react'
import { useOrderPreviewModal } from '../../components/OrderPreviewModal'

import { Header } from './components/Header'
import { OrderConfigurationView } from './components/OrderConfigurationView'
import { OrderExecutionView } from './components/OrderExecutionView'
import { OrderStepNotification } from './components/OrderStepNotification'

import type { Props } from './typings'

function renderPreviewTab(
  tab: number,
  extOrder: uui.domain.client.rm.ExtendedOrderStep,
  showOrderPreviewModal: (id: string, date: string) => void,
  getRecurrentOrder?: (id: string, date: string) => Promise<void>,
  isOpenedInOrderPreviewModal?: boolean,
) {
  switch (tab) {
    case 0:
      return (
        <OrderConfigurationView
          extOrder={extOrder}
          showOrderPreviewModal={showOrderPreviewModal}
          getRecurrentOrder={getRecurrentOrder}
          isOpenedInOrderPreviewModal={isOpenedInOrderPreviewModal}
        />
      )
    case 2:
      return <OrderStepNotification extendedOrder={extOrder} />
    case 1:
      return (
        <OrderExecutionView
          extOrder={extOrder}
          isOpenedInOrderPreviewModal={isOpenedInOrderPreviewModal}
        />
      )
    default:
      return null // Fallback for unexpected tab values
  }
}

export function SinglePreview(props: Props) {
  const { extOrder, tab, setTab, showHeader = true, getRecurrentOrder } = props
  const { show: showOrderPreviewModal, Modal: OrderPreviewModal } = useOrderPreviewModal()
  const [recurrentOrderIdentifier, setRecurrentOrderIdentifier] = useState<{
    recurrentOrderId: string
    date: string
  } | null>(null)

  const displayOrderPreview = useCallback(
    (orderId: string, date: string) => {
      setRecurrentOrderIdentifier({ recurrentOrderId: orderId, date })
      showOrderPreviewModal()
    },
    [showOrderPreviewModal],
  )

  const isOpenedInOrderPreviewModal = !showHeader

  return (
    <>
      <preview.Root
        applyPendingFitMapOnMount
        header={showHeader ? <Header extOrder={extOrder} tab={tab} setTab={setTab} /> : undefined}
      >
        {renderPreviewTab(
          tab,
          extOrder,
          displayOrderPreview,
          getRecurrentOrder,
          isOpenedInOrderPreviewModal,
        )}
      </preview.Root>
      <OrderPreviewModal
        recurrentOrderId={recurrentOrderIdentifier?.recurrentOrderId ?? null}
        date={recurrentOrderIdentifier?.date ?? null}
        type={extOrder.orderStep.type}
      />
    </>
  )
}
